import { v4 as uuidv4 } from 'uuid';
import { selectStateData } from 'src/core/redux/selectors';
import { PlateTemplate } from 'src/models';
import {
  state as stateConstants,
  status as statusConstants,
} from 'src/constants';

export const selectFileData = (state) => {
  const fileData = selectStateData(
    PlateTemplate.NAME,
    stateConstants.IDENTIFIER_TYPE_ITEM
  )(state);

  const file = {
    id: uuidv4(),
    name: fileData?.data?.fileName || '',
    size: fileData?.data?.size || 0,
    isUploading: fileData?.fetchDataMeta?.isFetching,
    uploaded: fileData?.fetchDataMeta?.fetched,
    data: fileData?.data || [],
    additionalData: new PlateTemplate(fileData?.data),
    nameWithoutExtension: fileData?.data?.fileName ?
      fileData?.data?.fileName.split('.').slice(0, -1).join('.') :
      '',
    errorMessages: fileData?.data?.errorMessages,
  };

  switch (fileData?.status) {
    case statusConstants.PENDING:
      file.processed = false;
      break;
    case statusConstants.SUCCESS:
      file.processed = true;
      break;
    case statusConstants.ERROR:
      file.processed = false;
      file.status = fileData?.status;
      file.errorMessages = fileData?.errorMessages || file.errorMessages;
      break;
    default:
      return {};
  }

  return file;
};
